import { render, staticRenderFns } from "./EmdLoader.vue?vue&type=template&id=5f954bf7&"
import script from "./EmdLoader.vue?vue&type=script&lang=js&"
export * from "./EmdLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f954bf7')) {
      api.createRecord('5f954bf7', component.options)
    } else {
      api.reload('5f954bf7', component.options)
    }
    module.hot.accept("./EmdLoader.vue?vue&type=template&id=5f954bf7&", function () {
      api.rerender('5f954bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/atoms/EmdLoader.vue"
export default component.exports